import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import Stepper from "./Components/stepper";
import Row1 from "./Components/Row1";
import AdditionalServices from "./Components/AdditionalServices";
import FulfilmentLocation from "./Components/FulfilmentLocation/FulfilmentLocation";
import Row2 from "./Components/Row2";
import Row3 from "./Components/Row3";
import FinalStep from "./Components/FinalStep";
import { useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { addUser } from "../../../../../store/userSlice";
import InternationalForm from "./Components/InternationalForm";
import { showSnackBar } from "../../../../../store/common/snackBarSlice";
import {
  quoteService,
  specficQuoteService,
  createShipmentService,
} from "../../../../../services/ShipperServices/Shipping/shipping.services";
// Keep last: its size floors must load after the component stylesheets.
import "./readability.css";

function getNextDay() {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  const month = (tomorrow.getMonth() + 1).toString().padStart(2, "0");
  const day = tomorrow.getDate().toString().padStart(2, "0");
  return `${tomorrow.getFullYear()}-${month}-${day}`;
}

const initial_internationl = {
  products: [
    {
      Description: "",
      Country: "",
      OriginCountryCode: "",
      TotalPriceAmount: "",
      CommodityCode: "",
      Count: "",
    },
  ],
  producer: {
    CompanyName: "",
    Country: "",
    CountryCode: "",
  },
  InsuranceAmount: "",
  ReasonForExport: "",
  ExportReasonType: "",
  duties_by: "receiver",
};

const initial_stepcheck = {
  ShipmentCheck: false,
  QuoteCheck: false,
  Pickup_Address_bit: 1,
  Delivery_Address_bit: 1,
  Additional_services_bit: 1,
  Packages_bit: 1,
  Quote_bit: 1,
  insurancetype: "Shipment",
  TotalWeight: 0,
  TotalVolume: 0,
  type: "Package",
  unit: "Imperial",
  fullform: false,
  ShipmentType: "",
  serviceType: "",
  Shipmentby: "",
  QuoteData: [],
  SingleQuoteData: "",
  FinalData: "",
  Pending: true,
  Final_Order: false,
  Disable: "",
  Products: "Products",
  Package: true,
  Pallet: false,
  International: initial_internationl,
  Warehouses: "",
  TotalFulfilmentCost: 0,
};

const initial_Flist = {
  address: "",
  country: "",
  countrycode: "",
  state: "",
  statecode: "",
  city: "",
  zip: "",
  company: "",
  id: "",
  attention: "",
  phone: "",
  otime: "",
  ctime: "",
  residential: false,
  date: getNextDay(),
  email: "",
  notification: false,
  instruction: "",
  ref: "",
  type: "Flist",
};

const initial_Tlist = {
  address: "",
  country: "",
  countrycode: "",
  state: "",
  statecode: "",
  city: "",
  zip: "",
  company: "",
  id: "",
  attention: "",
  phone: "",
  email: "",
  instruction: "",
  residential: false,
  notification: false,
  otime: "",
  ctime: "",
  date: "",
  ref: "",
  type: "Tlist",
};

const initial_Alist = {
  signature: false,
  residential: false,
  notification: false,
  returnlabel: false,
  insurance: false,
  insurancevalue: "",
  fragile: false,
  paperinvoice: false,
  dangerious: false,
  appointment: false,
  thirdpartybilling: false,
  cashondelivery: false,
  cashondeliveryvalue: "",
  ref: "",
  tailgatedelivery: false,
  tailgatepickup: false,
};

const initial_Aplist = {
  signature: false,
  residential: false,
  notification: false,
  returnlabel: false,
  insurance: false,
  insurancevalue: "",
  fragile: false,
  paperinvoice: false,
  dangerious: false,
  appointment: false,
  thirdpartybilling: false,
  cashondelivery: false,
  cashondeliveryvalue: "",
  ref: "",
};

const initial_Plist = [
  {
    name: "",
    length: "",
    width: "",
    height: "",
    weight: "",
    volume: "",
    insurance: "",
    description: "",
    feright: "",
    nmfc: "",
    type: "",
    pieces: "",
    link_key: "",
  },
];

const initial_stepper = {
  Pickup_Address: 0,
  Delivery_Address: 0,
  Packages: 0,
  Quote: 0,
  Additional_services: 0,
  ShipmentCheck: false,
};

function Ship() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);

  const [stepcheck, setstepcheck] = useState(initial_stepcheck);

  const [Flist, setFlist] = useState(initial_Flist);

  const [Tlist, setTlist] = useState(initial_Tlist);

  const [Alist, setAlist] = useState(initial_Alist);

  const [Aplist, setAplist] = useState(initial_Aplist);

  const [Plist, setPlist] = useState(initial_Plist);

  const [SelectedProducts, setSelectedProducts] = useState([]);
  const [shopifyProducts, setshopifyProducts] = useState([]);

  const [stepper, setStepper] = useState(initial_stepper);

  const Getquote = (event) => {
    event.preventDefault();

    setstepcheck((prevStepCheck) => ({
      ...prevStepCheck,
      Pending: true,
      QuoteCheck: true,
      QuoteData: [],
    }));

    const payload = {
      unit: stepcheck["unit"],
      fromzip: Flist["zip"],
      fromcountry: Flist["country"],
      fromstate: Flist["state"],
      fromcity: Flist["city"],
      fromcountrycode: Flist["countrycode"],
      fromstatecode: Flist["statecode"],
      fresidential: Flist["residential"],
      tozip: Tlist["zip"],
      tocountry: Tlist["country"],
      tostate: Tlist["state"],
      tocity: Tlist["city"],
      tocountrycode: Tlist["countrycode"],
      tostatecode: Tlist["statecode"],
      tresidential: Tlist["residential"],
      dimensions: Plist,
      totalweight: stepcheck["TotalWeight"],
      signature: Alist["signature"],

      insurance: Alist["insurance"],
      insurance_amount: Alist["insurancevalue"],
      insurance_type: stepcheck["insurancetype"],
      tailgate_pickup: Alist["tailgatepickup"],
      tailgate_delivery: Alist["tailgatedelivery"],
    };

    quoteService(stepcheck, setstepcheck, payload);
  };

  const GetSpecific = async (event) => {
    event.preventDefault();

    const requestData = {
      unit: stepcheck["unit"],
      totalweight: stepcheck["TotalWeight"],
      type: stepcheck["ShipmentType"],
      service_type: stepcheck["serviceType"],

      fromzip: Flist["zip"],
      fromcountry: Flist["country"],
      fromstate: Flist["state"],
      fromcity: Flist["city"],
      fromcountrycode: Flist["countrycode"],
      fromstatecode: Flist["statecode"],
      fresidential: Flist["residential"],
      fromnotification: Flist["notification"],

      tocountry: Tlist["country"],
      tostate: Tlist["state"],
      tocity: Tlist["city"],
      tozip: Tlist["zip"],
      tocountrycode: Tlist["countrycode"],
      tostatecode: Tlist["statecode"],
      tresidential: Tlist["residential"],
      tonotification: Tlist["notification"],

      signature: Alist["signature"],
      dangerous: Alist["dangerious"],
      fragile: Alist["fragile"],
      return_label: Alist["returnlabel"],
      paper_invoice: Alist["paperinvoice"],
      appointment: Alist["appointment"],
      cash_on_delivery: Alist["cashondelivery"],
      cash_on_delivery_value: Alist["cashondeliveryvalue"],

      pickup_date: Flist["date"],
      delivery_date: Tlist["date"],

      insurance: Alist["insurance"],
      insurance_amount: Alist["insurancevalue"],
      insurance_type: stepcheck["insurancetype"],
      tailgate_pickup: Alist["tailgatepickup"],
      tailgate_delivery: Alist["tailgatedelivery"],

      dimensions: Plist,
      // international: // Will be used for ups landing cost.
      //   Tlist.country &&
      //   Tlist.countrycode &&
      //   Flist.country &&
      //   Flist.countrycode &&
      //   !(
      //     ["Canada", "canada"].includes(Tlist.country) &&
      //     ["CA", "ca"].includes(Tlist.countrycode) &&
      //     ["Canada", "canada"].includes(Flist.country) &&
      //     ["CA", "ca"].includes(Flist.countrycode)
      //   )
      //     ? stepcheck["International"]
      //     : [],
    };
    setstepcheck((prevStepCheck) => ({
      ...prevStepCheck,
      Disable: "finalquote",
      credit_card_payment_method_id: "",
      QuoteCheck: true,
    }));

    try {
      const response = await specficQuoteService(
        stepcheck["Shipmentby"],
        requestData,
      );
      if (!response?.error && response?.data?.success === true) {
        const finalQuote = response?.data?.result?.[0];

        // Always parse as float (keep decimals)
        const subTotal = Number(finalQuote?.sub_total) || 0;

        // Processing fee (3% of subtotal)
        const processingFee = subTotal * 0.03;

        // Updated total for tax calculation (subtotal + processing fee)
        const updatedSubTotal = subTotal + processingFee;

        // Calculate tax charges based on updated total
        let totalTax = 0;
        const taxCharges = (finalQuote?.tax_charges || []).map((tax) => {
          const percentage = Number(tax?.percentage || 0);
          const taxCharge = (updatedSubTotal * percentage) / 100;
          totalTax += taxCharge;

          return {
            Id: tax?.Id,
            Charge: taxCharge,
            NameEn: tax?.NameEn,
            percentage: percentage,
          };
        });

        // Build with-card charge data (2 decimal everywhere)
        const withCardFinalCharge = {
          sub_total: updatedSubTotal.toFixed(2),
          processing_fee: processingFee.toFixed(2),
          tax_charges: taxCharges.map((t) => ({
            ...t,
            Charge: t.Charge.toFixed(2),
          })),
          total_tax_charges: totalTax.toFixed(2),
          total: (updatedSubTotal + totalTax).toFixed(2), // subtotal + processingFee + taxes
        };

        // Build without-card charge data
        const withoutCardFinalCharge = {
          sub_total: Number(finalQuote?.sub_total || 0).toFixed(2),
          tax_charges: (finalQuote?.tax_charges || []).map((t) => ({
            ...t,
            Charge: Number(t.Charge || 0).toFixed(2),
          })),
          total: Number(finalQuote?.total || 0).toFixed(2),
        };

        // Update state
        setstepcheck((prevStepCheck) => ({
          ...prevStepCheck,
          QuoteCheck: true,
          SingleQuoteData: finalQuote,
          withCardFinalCharge,
          withoutCardFinalCharge,
          serviceType: finalQuote?.service_type,
          Disable: "",
          Final_Order: true,
        }));
      } else {
        setstepcheck((prevStepCheck) => ({
          ...prevStepCheck,
          Disable: "",
          QuoteCheck: true,
        }));
        dispatch(
          showSnackBar({
            text: response?.data?.message ?? "Something went wrong",
            severity: "error",
          }),
        );
      }
    } catch (error) {
      setstepcheck((prevStepCheck) => ({
        ...prevStepCheck,
        Disable: "",
        QuoteCheck: true,
      }));
      dispatch(
        showSnackBar({
          text: error?.response?.data?.message ?? "Something went wrong",
          severity: "error",
        }),
      );
    }
  };

  const CreateShipment = async (event) => {
    event.preventDefault();
    setstepcheck((prevStepCheck) => ({
      ...prevStepCheck,
      Disable: "final",
    }));

    let salePrice = 0;
    const itemsArray = SelectedProducts.map((product, index) => {
      // Extract relevant information from each product
      salePrice += parseFloat(product.sale_price ?? 0) * product.quantity;
      const item = {
        ...(product?.order_actions?.id && {
          id: product.order_actions.id,
        }),
        item_id: product.id,
        productLotData: product?.productLotData ?? null,
        active_price: product.sale_price,
        regular_price: product.regular_price,
        sale_price: product.sale_price,
        sku: product.code,
        fulfillment_cost: product.fulfillment_cost,
        product_name: product.full_name,
        item_quantity: product.quantity,
        length: product.length,
        width: product.width,
        height: product.height,
        weight: product.weight,
        product_length_type: "Imperial",
        bolt_package_detail: product.package_details,
        item_subtotal: product.sale_price,
        item_subto_tax: 0,
        item_total: product.sale_price,
        item_total_tax: 0,
        item_tax_status: "taxable",
        note: product.note ?? "",
        link_key: product.link_key ?? null,
      };

      return item;
    });

    const order_details = {
      warehouse_id: stepcheck["Warehouses"],
      currency: "CAD",
      discount_total: 0,
      discount_tax: 0,
      type: "Manual",
      order_status_id: "2",
      total: salePrice,
      total_tax: 0,
      status: "Confirmed",
      items: itemsArray,
      fulfillment_cost: stepcheck.TotalFulfilmentCost,
      deleted_item_ids: stepcheck?.deleted_item_ids ?? [],
      formula: {
        TotalFulfilmentCost: stepcheck.TotalFulfilmentCost,
        TotalWeightCost: stepcheck.TotalWeightCost,
        TotalPreCost: stepcheck.TotalPreCost,
        TotalFulfilmentWeight: stepcheck.TotalFulfilmentWeight,
        TotalPreProduct: stepcheck.TotalPreProduct,
        UnitType: stepcheck.UnitType,
        Formula: stepcheck.Formula,
      },
      warehouse: {
        full_address: Flist["address"],
        country: Flist["countrycode"],
        country_name: Flist["country"],
        state_provience: Flist["statecode"],
        state_name: Flist["state"],
        city_town: Flist["city"],
        zip_postal: Flist["zip"],
        company: Flist["company"],
        attention: Flist["attention"],
        phone: Flist["phone"],
        email: Flist["email"],
      },
      billing: {
        first_name: Tlist["attention"],
        company: Tlist["company"],
        address_1: Tlist["address"],
        address_2: "",
        city: Tlist["city"],
        state: Tlist["statecode"],
        postcode: Tlist["zip"],
        country: Tlist["countrycode"],
        email: Tlist["email"],
        phone: Tlist["phone"],
      },
      shipping: {
        first_name: Tlist["attention"],
        company: Tlist["company"],
        address_1: Tlist["address"],
        address_2: "",
        city: Tlist["city"],
        state: Tlist["statecode"],
        state_name: Tlist["state"],
        postcode: Tlist["zip"],
        country: Tlist["countrycode"],
        country_name: Tlist["country"],
        phone: Tlist["phone"],
      },
    };

    if (Tlist?.ref && !stepcheck?.Order_id) {
      order_details.order_id = Tlist.ref;
    }

    const charges = stepcheck?.credit_card_payment_method_id
      ? stepcheck?.withCardFinalCharge
      : stepcheck?.withoutCardFinalCharge;

    const { sub_total: SubTotal, total: Total } = charges ?? {};

    const Data = {
      company_id: stepcheck["Shipmentby"],
      unit: stepcheck["unit"],
      package_type: stepcheck["type"],
      total_weight: stepcheck["TotalWeight"],
      volume: stepcheck["TotalVolume"],

      insurance: Alist["insurance"],
      insurance_amount: Alist["insurancevalue"],
      insurance_type: stepcheck["insurancetype"],
      tailgate_pickup: Alist["tailgatepickup"],
      tailgate_delivery: Alist["tailgatedelivery"],

      signature: Alist["signature"],
      return_label: Alist["returnlabel"],
      shipment_status: "Creation",
      dangerous: Alist["dangerious"],
      fragile: Alist["fragile"],
      paper_invoice: Alist["paperinvoice"],
      appointment: Alist["appointment"],
      cash_on_delivery: Alist["cashondelivery"],
      cash_on_delivery_value: Alist["cashondeliveryvalue"],

      fcountry: Flist["country"],
      fcountrycode: Flist["countrycode"],
      fcity: Flist["city"],
      fstate: Flist["state"],
      fstatecode: Flist["statecode"],
      fzip: Flist["zip"],
      fid: Flist["id"],
      fcompany: Flist["company"],
      fphone: Flist["phone"],
      fattension: Flist["attention"],
      femail: Flist["email"],
      fnotification: Flist["notification"],
      finstructions: Flist["instruction"],
      readyopentime: Flist["otime"],
      readyclosetime: Flist["ctime"],
      shipdate: Flist["date"],
      faddress: Flist["address"],
      fresidential: Flist["residential"],
      f_reference: Flist["ref"],

      tcountry: Tlist["country"],
      tcountrycode: Tlist["countrycode"],
      tcity: Tlist["city"],
      tstate: Tlist["state"],
      tstatecode: Tlist["statecode"],
      tzip: Tlist["zip"],
      tcompany: Tlist["company"],
      tid: Tlist["id"],
      tphone: Tlist["phone"],
      tattension: Tlist["attention"],
      temail: Tlist["email"],
      tnotification: Tlist["notification"],
      tinstructions: Tlist["instruction"],
      taddress: Tlist["address"],
      tresidential: Tlist["residential"],
      deliveryopentime: Tlist["otime"],
      deliveryclosetime: Tlist["ctime"],
      referance_code: Tlist["ref"],

      dimensions: Plist,
      shipment_details: JSON.stringify(Plist),

      estimated_delivery_date: stepcheck["SingleQuoteData"]["delivery_date"],
      delivery_date: stepcheck["SingleQuoteData"]["delivery_date"],
      shipping_company_id: stepcheck["SingleQuoteData"]["comp_id"],
      BasePrice: stepcheck["SingleQuoteData"]["base_charge"],
      SubTotal: SubTotal,
      Total: Total,
      pickup_zone: stepcheck["SingleQuoteData"]["pickupZone"],
      delivery_zone: stepcheck["SingleQuoteData"]["deliveryZone"],
      type: stepcheck["ShipmentType"],
      service_type: stepcheck["SingleQuoteData"]["service_type"],
      response: stepcheck["SingleQuoteData"],
      credit_card_payment_method_id: stepcheck["credit_card_payment_method_id"],

      international:
        Tlist.country &&
        Tlist.countrycode &&
        Flist.country &&
        Flist.countrycode &&
        !(
          ["Canada", "canada"].includes(Tlist.country) &&
          ["CA", "ca"].includes(Tlist.countrycode) &&
          ["Canada", "canada"].includes(Flist.country) &&
          ["CA", "ca"].includes(Flist.countrycode)
        )
          ? stepcheck["International"]
          : [],

      order: order_details,
      order_id: stepcheck["Order_id"] ?? "",
      fulfillment_cost: stepcheck.TotalFulfilmentCost,
      sale:
        stepcheck["Warehouses"] &&
        (SelectedProducts.length > 0 ||
          stepcheck?.deleted_item_ids?.length > 0),
    };

    const response = await createShipmentService(stepcheck["Shipmentby"], Data);
    if (!response?.error) {
      if (response?.data?.success === true) {
        setstepcheck((prevStepCheck) => ({
          ...prevStepCheck,
          Disable: "",
          ShipmentCheck: true,
          Final_Order: false,
          FinalData: response?.data?.result,
        }));

        // Updating Store and Local Storage
        let key = "balance";
        let value = response.data.result.userBalance;
        const updatedUser = {
          ...user,
          balance: value,
          unReadShipments: (user.unReadShipments ?? 0) + 1,
          unReadPickups: (user.unReadPickups ?? 0) + 1,
          unReadTrackings: (user.unReadTrackings ?? 0) + 1,
          unReadInvoices: (user.unReadInvoices ?? 0) + 1,
        };
        dispatch(addUser(updatedUser));

        localStorage.setItem("user", JSON.stringify(updatedUser));
        // Updating Store and Local Storage
        dispatch(
          showSnackBar({
            text: response?.data?.message,
            severity: "success",
          }),
        );
      } else {
        dispatch(
          showSnackBar({
            text: response?.data?.message ?? "Something went wrong",
            severity: "error",
          }),
        );
        setstepcheck((prevStepCheck) => ({
          ...prevStepCheck,
          Disable: "",
        }));
      }
    } else {
      dispatch(
        showSnackBar({
          text:
            response?.error?.response?.data?.message ?? "Something went wrong",
          severity: "error",
        }),
      );
      setstepcheck((prevStepCheck) => ({
        ...prevStepCheck,
        Disable: "",
      }));
    }
  };

  useEffect(() => {
    // Address
    let Pickup_Address = 1;
    let Delivery_Address = 1;
    if (stepcheck["fullform"] === false) {
      // Pickup Address
      if (
        Flist["country"] !== "" &&
        Flist["city"] !== "" &&
        Flist["state"] !== "" &&
        Flist["zip"] !== ""
      ) {
        // Complete and edited is done, as for the delivery address (this was
        // the other way round, so a filled-in pickup never showed done:
        // KNOWN_ISSUES SP-010, fixed 2026-10-19).
        if (stepcheck["Pickup_Address_bit"] === 1) {
          Pickup_Address = 0;
        } else {
          Pickup_Address = 1;
        }
      } else {
        if (
          stepcheck["Pickup_Address_bit"] === 1 &&
          stepcheck["Delivery_Address_bit"] === 1 &&
          stepcheck["Packages_bit"] === 1
        ) {
          Pickup_Address = 0;
        } else {
          Pickup_Address = 2;
        }
      }
      // Pickup Address

      // Delivery Address
      if (
        Tlist["country"] !== "" &&
        Tlist["city"] !== "" &&
        Tlist["state"] !== "" &&
        Tlist["zip"] !== ""
      ) {
        if (stepcheck["Delivery_Address_bit"] === 1) {
          Delivery_Address = 0;
        } else {
          Delivery_Address = 1;
        }
      } else {
        if (
          stepcheck["Delivery_Address_bit"] === 1 &&
          stepcheck["Packages_bit"] === 1
        ) {
          Delivery_Address = 0;
        } else {
          Delivery_Address = 2;
        }
      }
      // Delivery Address
    } else {
      // Pickup Address
      if (
        Flist["address"] !== "" &&
        Flist["country"] !== "" &&
        Flist["city"] !== "" &&
        Flist["state"] !== "" &&
        Flist["zip"] !== "" &&
        Flist["company"] !== "" &&
        Flist["phone"] !== "" &&
        Flist["attension"] !== "" &&
        // Flist[0]["femail"] !== "" &&
        Flist["date"] !== ""
      ) {
        // Complete and edited is done (SP-010, as above).
        if (stepcheck["Pickup_Address_bit"] === 1) {
          Pickup_Address = 0;
        } else {
          Pickup_Address = 1;
        }
      } else {
        if (
          stepcheck["Pickup_Address_bit"] === 1 &&
          stepcheck["Delivery_Address_bit"] === 1 &&
          stepcheck["Packages_bit"] === 1
        ) {
          Pickup_Address = 0;
        } else {
          Pickup_Address = 2;
        }
      }
      // Pickup Address

      // Delivery Address
      if (
        Tlist["address"] !== "" &&
        Tlist["country"] !== "" &&
        Tlist["city"] !== "" &&
        Tlist["state"] !== "" &&
        Tlist["zip"] !== "" &&
        Tlist["company"] !== "" &&
        Tlist["phone"] !== "" &&
        Tlist["attension"] !== ""
        // Tlist[0]["temail"] !== "" &&
        // Tlist[0]["tdeliverdate"] !== ""
      ) {
        if (stepcheck["Delivery_Address_bit"] === 1) {
          Delivery_Address = 0;
        } else {
          Delivery_Address = 1;
        }
      } else {
        if (
          stepcheck["Delivery_Address_bit"] === 1 &&
          stepcheck["Packages_bit"] === 1
        ) {
          Delivery_Address = 0;
        } else {
          Delivery_Address = 2;
        }
      }
      // Delivery Address
    }
    // Address

    // Packages
    // Filled in is done, typed now or already there. A saved package left in
    // the first row by an earlier visit or Ship More (KNOWN_ISSUES SP-029, itself fixed 2026-10-20)
    // counted as to do until edited, so Dimension & Weight, and Additional
    // services with it, stayed to do even after booking with it (fixed
    // 2026-10-19). Missing is still to do until edited, then needs attention.
    let Packages = 1;
    Plist.forEach((element) => {
      if (
        element.length !== "" &&
        element.height !== "" &&
        element.width !== "" &&
        element.weight !== ""
      ) {
        Packages = 1;
      } else {
        if (stepcheck["Packages_bit"] === 1) {
          Packages = 0;
        } else {
          Packages = 2;
        }
      }
      if (
        Alist["insurance"] === true &&
        stepcheck["insurancetype"] !== "Shipment"
      ) {
        if (element.insurance !== "") {
          Packages = 1;
        } else {
          if (stepcheck["Packages_bit"] === 1) {
            Packages = 0;
          } else {
            Packages = 2;
          }
        }
      }
    });
    // Packages

    //  Quote
    // Done while quotes are on the page and one is picked. It was done as soon
    // as a carrier had ever been picked, so after an edit took the quotes
    // away, or on Ship Order before any quote, the next step showed as Book
    // Shipment (INVENTORY entry-12 and the edit case; fixed 2026-10-19 with
    // SP-010). Shipmentby itself, and so the payload, is unchanged.
    let Quote = 1;
    if (stepcheck["Shipmentby"] === "" || stepcheck["QuoteCheck"] !== true) {
      Quote = 0;
    } else {
      Quote = 1;
    }
    // Quote

    //  Additonal Services
    // Optional: done once something in it or in the packages was edited, and
    // (2026-10-19, with the Packages fix above) once Dimension & Weight is
    // done, so a package already there no longer leaves it as the next step.
    let Additional_services = 1;
    if (
      Alist["insurance"] === true &&
      stepcheck["insurancetype"] === "Shipment" &&
      Alist["insurancevalue"] === ""
    ) {
      Additional_services = 2;
    } else {
      if (
        stepcheck["Additional_services_bit"] === 1 &&
        stepcheck["Packages_bit"] === 1 &&
        Packages !== 1
      ) {
        Additional_services = 0;
      } else {
        Additional_services = 1;
      }
    }
    // Additonal Services

    setStepper((prev) => ({
      ...prev,
      Pickup_Address,
      Delivery_Address,
      Packages,
      Quote,
      Additional_services,
      ShipmentCheck: stepcheck["ShipmentCheck"],
    }));
  }, [Flist, Tlist, stepcheck, Alist]);

  const reset = () => {
    setstepcheck(initial_stepcheck);
    setFlist(initial_Flist);
    setTlist(initial_Tlist);
    setAlist(initial_Alist);
    setPlist(initial_Plist);
    setStepper(initial_stepper);
  };

  useEffect(() => {
    const storedReship = localStorage.getItem("Reship");
    if (!storedReship) {
      localStorage.removeItem("Reship");
      return;
    }

    const Reship = JSON.parse(storedReship);
    localStorage.removeItem("Reship");

    const {
      faddress,
      fcountry,
      fcountrycode,
      fstate,
      fstatecode,
      fcity,
      fzip,
      fcompany,
      fid,
      fattension,
      fphone,
      readyopentime,
      readyclosetime,
      fresidential,
      femail,
      fnotification,
      finstructions,
      taddress,
      tcountry,
      tcountrycode,
      tstate,
      tstatecode,
      tcity,
      tzip,
      tcompany,
      tid,
      tattension,
      tphone,
      deliveryopentime,
      deliveryclosetime,
      tresidential,
      temail,
      tnotification,
      tinstructions,
      referance_code,
      signature,
      return_label,
      insurance,
      insurance_amount,
      fragile,
      paper_invoice,
      dangerous,
      appointment,
      cash_on_delivery,
      cash_on_delivery_value,
      insurance_type,
      package_type,
      unit,
      international,
      shipment_details,
    } = Reship;

    setFlist({
      address: faddress ?? "",
      country: fcountry ?? "",
      countrycode: fcountrycode ?? "",
      state: fstate ?? "",
      statecode: fstatecode ?? "",
      city: fcity ?? "",
      zip: fzip ?? "",
      company: fcompany ?? "",
      id: fid ?? "",
      attention: fattension ?? "",
      phone: fphone ?? "",
      otime: readyopentime ?? "",
      ctime: readyclosetime ?? "",
      residential: fresidential,
      date: getNextDay(),
      email: femail ?? "",
      notification: fnotification,
      instruction: finstructions ?? "",
      ref: "",
      type: "Flist",
    });

    setTlist({
      address: taddress ?? "",
      country: tcountry ?? "",
      countrycode: tcountrycode ?? "",
      state: tstate ?? "",
      statecode: tstatecode ?? "",
      city: tcity ?? "",
      zip: tzip ?? "",
      company: tcompany ?? "",
      id: tid ?? "",
      attention: tattension ?? "",
      phone: tphone ?? "",
      otime: deliveryopentime ?? "",
      ctime: deliveryclosetime ?? "",
      residential: tresidential,
      date: "",
      email: temail ?? "",
      notification: tnotification,
      instruction: tinstructions ?? "",
      ref: referance_code ?? "",
      type: "Tlist",
    });

    setAlist({
      signature,
      residential: false,
      notification: false,
      returnlabel: return_label,
      insurance,
      insurancevalue: insurance_amount ?? "",
      fragile,
      paperinvoice: paper_invoice,
      dangerious: dangerous,
      appointment,
      thirdpartybilling: false,
      cashondelivery: cash_on_delivery,
      cashondeliveryvalue: cash_on_delivery_value ?? "",
    });

    setstepcheck({
      ShipmentCheck: false,
      QuoteCheck: false,
      Pickup_Address_bit: 0,
      Delivery_Address_bit: 0,
      Additional_services_bit: 0,
      Packages_bit: 0,
      Quote_bit: 1,
      insurancetype: insurance_type ?? "Shipment",
      TotalWeight: 0,
      TotalVolume: 0,
      type: package_type ?? "Package",
      unit: unit ?? "Imperial",
      fullform: true,
      ShipmentType: "",
      Shipmentby: "",
      QuoteData: [],
      SingleQuoteData: "",
      FinalData: "",
      Pending: true,
      Final_Order: false,
      Disable: "",
      Products: "Packages",
      Package: true,
      Pallet: false,
      International: international?.products
        ? international
        : initial_internationl,
      Warehouses: "",
      TotalFulfilmentCost: 0,
    });

    setPlist(
      shipment_details?.map(
        ({
          length,
          width,
          height,
          weight,
          volume,
          insurance,
          description,
          feright,
          nmfc,
          type,
          pieces,
        }) => ({
          name: "",
          length: length ?? "",
          width: width ?? "",
          height: height ?? "",
          weight: weight ?? "",
          volume: volume ?? "",
          insurance: insurance ?? "",
          description: description ?? "",
          feright: feright ?? "",
          nmfc: nmfc ?? "",
          type: type ?? "",
          pieces: pieces ?? "",
          link_key: "",
        }),
      ) || [],
    );
  }, []);

  const loadOrderShipment = useCallback(() => {
    try {
      const orderShipment = localStorage.getItem("OrderShipment");

      if (!orderShipment) {
        return;
      }

      const parsedOrderShipment = JSON.parse(orderShipment);

      const pickupDetails =
        parsedOrderShipment?.order_pickup_details?.[0] || {};
      const shippingAddressDetails =
        parsedOrderShipment?.order_shipping_address_details || {};
      const billingAddressDetails =
        parsedOrderShipment?.order_billing_address_details || {};

      // Consolidating state updates
      setFlist({
        address: pickupDetails?.full_address ?? "",
        country: pickupDetails?.country_name ?? "",
        countrycode: pickupDetails?.country ?? "",
        state: pickupDetails?.state_name ?? "",
        statecode: pickupDetails?.state_provience ?? "",
        city: pickupDetails?.city_town ?? "",
        zip: pickupDetails?.zip_postal ?? "",
        company: pickupDetails?.company ?? "",
        id: "",
        attention: pickupDetails?.attention ?? "",
        phone: pickupDetails?.phone ?? "",
        otime: "",
        ctime: "",
        residential: false,
        date: getNextDay(),
        email: pickupDetails?.email ?? "",
        notification: false,
        instruction: "",
        ref: "",
        type: "Flist",
      });

      setTlist({
        address: `${shippingAddressDetails?.address_1 ?? ""} ${
          shippingAddressDetails?.address_2 ?? ""
        }`.trim(),
        country: shippingAddressDetails?.country_name ?? "",
        countrycode: shippingAddressDetails?.country ?? "",
        state: shippingAddressDetails?.state_name ?? "",
        statecode: shippingAddressDetails?.state ?? "",
        city: shippingAddressDetails?.city ?? "",
        zip: shippingAddressDetails?.postcode ?? "",
        company: `${shippingAddressDetails?.first_name ?? ""} ${
          shippingAddressDetails?.last_name ?? ""
        }`,
        id: "",
        attention: `${shippingAddressDetails?.first_name ?? ""} ${
          shippingAddressDetails?.last_name ?? ""
        }`,
        phone: billingAddressDetails?.phone ?? "",
        otime: "",
        ctime: "",
        residential: false,
        date: "",
        email: billingAddressDetails?.email ?? "",
        notification: false,
        instruction: parsedOrderShipment?.customer_note ?? "",
        ref: parsedOrderShipment?.order_id ?? "",
        type: "Tlist",
      });

      setAlist({
        signature: false,
        residential: false,
        notification: false,
        returnlabel: false,
        insurance: false,
        insurancevalue: "",
        fragile: false,
        paperinvoice: false,
        dangerious: false,
        appointment: false,
        thirdpartybilling: false,
        cashondelivery: false,
        cashondeliveryvalue: "",
      });

      setstepcheck({
        ShipmentCheck: false,
        QuoteCheck: false,
        Pickup_Address_bit: 0,
        Delivery_Address_bit: 0,
        Additional_services_bit: 0,
        Packages_bit: 0,
        Quote_bit: 1,
        insurancetype: "Shipment",
        TotalWeight: 0,
        TotalVolume: 0,
        type: "Package",
        unit: "Imperial",
        fullform: true,
        ShipmentType: "",
        serviceType:
          parsedOrderShipment?.selected_shipping_detail?.["Service-type"] ?? "",
        Shipmentby:
          parsedOrderShipment?.selected_shipping_detail?.["Comp-id"] ?? "",
        QuoteData: [],
        SingleQuoteData: "",
        FinalData: "",
        Pending: true,
        Final_Order: false,
        Disable: "",
        Products: "Products",
        Package: true,
        Pallet: false,
        International: initial_internationl,
        Warehouses: parsedOrderShipment?.warehouse_id ?? "",
        TotalFulfilmentCost: 0,
        Order_id: parsedOrderShipment?.id,
      });

      const newPlist = [];
      const newSelected = [];
      const newShopify = [];

      if (parsedOrderShipment?.order_details?.length) {
        parsedOrderShipment.order_details.forEach((item) => {
          const quantity = parseInt(item.item_quantity, 10);
          for (let i = 0; i < quantity; i++) {
            const newItem = {
              name: item.product_name || "",
              description: item.product_name || "",
              type: item.product_length_type || "Imperial",
              pieces: "",
              link_key: item.link_key ?? "",
            };

            // Process Bolt Package Details
            if (item?.bolt_package_detail?.length) {
              item.bolt_package_detail.forEach((boltItem) => {
                const isMetric = item.product_length_type === "Metric";
                newPlist.push({
                  ...newItem,
                  length: convertToImperial(
                    boltItem.length,
                    "length",
                    isMetric,
                  ),
                  width: convertToImperial(boltItem.width, "width", isMetric),
                  height: convertToImperial(
                    boltItem.height,
                    "height",
                    isMetric,
                  ),
                  weight: convertToImperial(
                    boltItem.weight,
                    "weight",
                    isMetric,
                  ),
                });
              });
            } else {
              newPlist.push({
                ...newItem,
                length: convertToImperial(
                  item.length,
                  "length",
                  item.product_length_type === "Metric",
                ),
                width: convertToImperial(
                  item.width,
                  "width",
                  item.product_length_type === "Metric",
                ),
                height: convertToImperial(
                  item.height,
                  "height",
                  item.product_length_type === "Metric",
                ),
                weight: convertToImperial(
                  item.weight,
                  "weight",
                  item.product_length_type === "Metric",
                ),
              });
            }

            if (i === 0) {
              if (item.products && !item.plugin_item_id) {
                const productWithOrderDetails = {
                  ...item.products,
                  quantity: quantity,
                  link_key: item.link_key ?? "",
                  order_actions: {
                    id: item.id,
                    deletedLotDataIds: [],
                  },
                };
                newSelected.push(productWithOrderDetails);
              } else if (item.plugin_item_id) {
                newShopify.push(item);
              }
            }
          }
        });

        setPlist(newPlist);
        setSelectedProducts(newSelected);
        setshopifyProducts(newShopify);
      } else {
        setPlist(initial_Plist);
      }

      // Function to convert metric to imperial
      function convertToImperial(metricValue, dataType, isMetric) {
        if (!isMetric || !metricValue) return metricValue;
        const value = parseFloat(metricValue);
        switch (dataType) {
          case "length":
          case "width":
          case "height":
            return (value / 2.54).toFixed(2);
          case "weight":
            return (value * 2.205).toFixed(2);
          default:
            return value;
        }
      }
    } catch (error) {
      console.error("Error while processing order shipment:", error);
    } finally {
      localStorage.removeItem("OrderShipment");
    }
  }, []);

  useEffect(() => {
    loadOrderShipment();
  }, [loadOrderShipment]);

  // console.log(Flist);
  // console.log(Tlist);
  // console.log(Alist);
  // console.log(Plist);
  // console.log(stepcheck);
  // useEffect(() => {
  // console.log(SelectedProducts);
  // }, [SelectedProducts]);

  return (
    // The progress rail sits in the cards' left margin (Components/stepper.css);
    // the wrapper is always there, so the form never remounts because of it.
    <div className={`shiprail-page${stepcheck["ShipmentCheck"] ? " is-booked" : ""}`}>
      <Stepper stepper={stepper} />

      {stepcheck["ShipmentCheck"] === false && (
        <Form
          onSubmit={
            stepcheck["QuoteCheck"] === false
              ? Getquote
              : stepcheck["Final_Order"] === true
                ? CreateShipment
                : GetSpecific
          }
        >
          {/* Row1 */}
          <Row1
            Flist={Flist}
            SetFlist={setFlist}
            Tlist={Tlist}
            SetTlist={setTlist}
            StepCheck={stepcheck}
            SetStepCheck={setstepcheck}
          />
          {/* Row1 */}

          {/* Addition services  */}
          <AdditionalServices
            List={Alist}
            SetList={setAlist}
            StepCheck={stepcheck}
            SetStepCheck={setstepcheck}
            Tlist={Tlist}
            setTlist={setTlist}
            Plist={Aplist}
          />
          {/* Addition services  */}

          {/* Fulfilment location: the warehouse choice, for the same roles as My Products */}
          {user?.role !== "oneTimeShipper" && (
            <FulfilmentLocation
              StepCheck={stepcheck}
              SetStepCheck={setstepcheck}
              Plist={Plist}
              SetPlist={setPlist}
              SelectedProducts={SelectedProducts}
              setSelectedProducts={setSelectedProducts}
            />
          )}

          {/* Row2 */}
          <Row2
            Plist={Plist}
            SetPlist={setPlist}
            Alist={Alist}
            SetAlist={setAlist}
            StepCheck={stepcheck}
            SetStepCheck={setstepcheck}
            Stepper={stepper}
            SelectedProducts={SelectedProducts}
            setSelectedProducts={setSelectedProducts}
            shopifyProducts={shopifyProducts}
            oneTimeShipper={user?.role !== "oneTimeShipper"}
          />
          {/* Row2 */}

          {/* Internationl Shipment Form */}
          <InternationalForm
            StepCheck={stepcheck}
            SetStepCheck={setstepcheck}
            isInternational={
              stepcheck["fullform"] === true &&
              stepcheck["QuoteCheck"] === true &&
              stepcheck["Shipmentby"] !== "" &&
              Tlist.country &&
              Tlist.countrycode &&
              Flist.country &&
              Flist.countrycode &&
              !(
                ["Canada", "canada"].includes(Tlist.country) &&
                ["CA", "ca"].includes(Tlist.countrycode) &&
                ["Canada", "canada"].includes(Flist.country) &&
                ["CA", "ca"].includes(Flist.countrycode)
              )
            }
          />
          {/* Internationl Shipment Form */}

          {/* Row3 */}
          <Row3
            StepCheck={stepcheck}
            Flist={Flist}
            Tlist={Tlist}
            Plist={Plist}
            SetStepCheck={setstepcheck}
            CreateShipment={CreateShipment}
          />
          {/* Row3 */}
        </Form>
      )}

      <FinalStep
        StepCheck={stepcheck}
        reset={reset}
        SetStepCheck={setstepcheck}
        oneTimeShipper={user?.role !== "oneTimeShipper"}
      />
    </div>
  );
}

export default Ship;
